import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=3c821dd2&scoped=true&lang=pug"
import script from "./AccountInfo.vue?vue&type=script&lang=js"
export * from "./AccountInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c821dd2",
  null
  
)

export default component.exports